import CorporateDataService from "../../../../context/corporates.services";

export const UpdateDeliveryAddress = async ({ id, value, enqueueSnackbar, setIsLoading }) => {
    try {
        if(value !== '') {
            setIsLoading(true);
            await CorporateDataService.updateCorporate('adressLivraisonCompany', value, id);
            enqueueSnackbar(`L'adresse de livraison a bien été modifiée en ${value}.`, {
                variant: 'success',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}
                   
            });
            return true;
        }else{
            enqueueSnackbar(`Veuillez séléctionner une adresse`, {
                variant: 'error',
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                autoHideDuration: 3000,
                style: {fontSize: '1.6rem'}  
            });
        }
    }catch(e) {
        enqueueSnackbar(`${e.message}`, {
            variant: 'error',
            anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            autoHideDuration: 3000,
            style: {fontSize: '1.6rem'}  
        });
        setIsLoading(false);
        return false;
    }
};